import { createContext } from "react";

const DrawerStackContext = createContext();

export default DrawerStackContext;